// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DeliveryOptions-module-radios-M\\+pX0 label{-webkit-margin-start:0;margin-inline-start:0;grid-gap:4px;gap:4px}.DeliveryOptions-module-description-4Jja0 p{margin-top:24px}.DeliveryOptions-module-customDeliveryOptionWrapper-WYrL0{margin:12px}.DeliveryOptions-module-selectedStore-aRArk{margin-block:24px;margin-inline:0}.DeliveryOptions-module-selectedStoreName-NqqMr{display:block}.DeliveryOptions-module-selectedStoreAddressLine-w-872{display:block}.DeliveryOptions-module-selectStoreCTA-kaPZg{margin-top:24px}.DeliveryOptions-module-addressError-fm3c-{margin-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radios": "DeliveryOptions-module-radios-M+pX0",
	"description": "DeliveryOptions-module-description-4Jja0",
	"customDeliveryOptionWrapper": "DeliveryOptions-module-customDeliveryOptionWrapper-WYrL0",
	"selectedStore": "DeliveryOptions-module-selectedStore-aRArk",
	"selectedStoreName": "DeliveryOptions-module-selectedStoreName-NqqMr",
	"selectedStoreAddressLine": "DeliveryOptions-module-selectedStoreAddressLine-w-872",
	"selectStoreCTA": "DeliveryOptions-module-selectStoreCTA-kaPZg",
	"addressError": "DeliveryOptions-module-addressError-fm3c-"
};
export default ___CSS_LOADER_EXPORT___;
